import React from 'react';
import {
  FooterWrapper, FooterGrid, FooterTitle, FooterLink, FooterBottom, Container,
} from '../styles/MFRealStateStyles';
import { MF_BASE } from '../basePath';
import { openContactModal } from './ContactModal';

export default function Footer() {
  return (
    <FooterWrapper>
      <Container>
        <FooterGrid>
          <div>
            <FooterTitle>MF Real Estate</FooterTitle>
            <p style={{ fontSize: 14, lineHeight: 1.6, marginBottom: 16 }}>
              Imóveis selecionados em Alphaville, Tamboré e Barueri.
              Atendimento personalizado para encontrar o imóvel ideal.
            </p>
          </div>

          <div>
            <FooterTitle>Navegação</FooterTitle>
            <FooterLink href={MF_BASE || '/'}>Home</FooterLink>
            <FooterLink href={`${MF_BASE}/imoveis`}>Imóveis</FooterLink>
            <FooterLink href={`${MF_BASE || '/'}#sobre`}>Depoimentos</FooterLink>
            <FooterLink href="#contato" onClick={(e) => { e.preventDefault(); openContactModal(); }}>Contato</FooterLink>
          </div>

          <div>
            <FooterTitle>Contato</FooterTitle>
            <FooterLink href="https://wa.me/5511999999999" target="_blank" rel="noopener noreferrer">
              WhatsApp
            </FooterLink>
            <FooterLink href="https://instagram.com/mf.lancamentos" target="_blank" rel="noopener noreferrer">
              Instagram
            </FooterLink>
          </div>
        </FooterGrid>

        <FooterBottom>
          MF Real Estate {new Date().getFullYear()}. Todos os direitos reservados.
        </FooterBottom>
      </Container>
    </FooterWrapper>
  );
}
